import { clientCookies } from 'utils/cookies';
import { COUPONS_INFO_SECTION_COOKIE } from '../consts';

export const COLLAPSE_COUPONS_INFO_SECTION = 'COLLAPSE_COUPONS_INFO_SECTION';
export const EXPAND_COUPONS_INFO_SECTION = 'EXPAND_COUPONS_INFO_SECTION';

export function collapseInfoSection() {
  clientCookies.set(
    COUPONS_INFO_SECTION_COOKIE.name,
    COUPONS_INFO_SECTION_COOKIE.value,
    COUPONS_INFO_SECTION_COOKIE.options
  );

  return {
    type: COLLAPSE_COUPONS_INFO_SECTION,
  };
}

export function expandInfoSection() {
  clientCookies.remove(COUPONS_INFO_SECTION_COOKIE.name);
  return {
    type: EXPAND_COUPONS_INFO_SECTION,
  };
}
